<!--实名制填写弹窗 -->
<template>
  <div v-if="display" v-modal-show="display" id="identityClass">
    <div class="mask"></div>
		<section class="M_wrap M_certification M_btn_1 M_top" style="top: 270px; display: block;">
			<p class="M_title T_18_25 T_b">实名认证</p>
			<div class="M_cont">
				<p class="T_12_18 T_w">根据国家规定，必须进行实名认证，才可体验游戏服务，为帮助未成年人防沉迷，请填写身份信息认证。</p>
			</div>
			<div class="M_form">
				<div class="M_f_item">
					<label for="" class="T_14_24">真实姓名</label>
				 <input type="text" v-model.trim="name" placeholder="请输入姓名">
				</div>
				<div class="M_f_item">
					<label for="" class="T_14_24">身份证号</label>
         <input type="text" v-model.trim="cardId" placeholder="请输入身份证号码">
				</div>
				<div class="M_f_btns cf">
					<a href="javascript:void(0);" class="M_btn T_w M_b_close" @click="confirm()" title="提交认证">提交认证</a>
				</div>
        <div class="M_f_coupon">
					<p class="M_f_c_amount T_12_16">
						<em>￥<i>{{ syMoney }}</i></em>
						<span>满￥{{ syOrder }}使用</span>
					</p>
					<p class="M_f_c_tip T_12_16">实名认证通过送{{ syMoney }}元代金券</p>
				</div>
			</div>
			<div class="M_cont">
				<p class="T_12_14 T_w">1、身份信息仅用于实名认证使用，本平台承诺绝不向任何第三方透露。</p>
				<p class="T_12_14 T_w">2、具体以游戏内活动为准。</p>
				<p class="T_12_14 T_w">3、如有任何疑问，请咨询阅文客服QQ：800038605</p>
			</div>
      <a class="M_close I_n" @click="close"></a>
		</section>



  </div>
</template>

<script>
  export default {
    data () {
      return {
        display: false,
        cardId: '',
        name: ''
      }
    },
    props: {
      confirmCallback: {
        type: Function,
        required: false
      },
      closeCallback: {
        type: Function,
        required: false
      },
      syMoney: {
        type: Number,
        required: false
      },
      syOrder: {
        type: Number,
        required: false
      }
    },
    created: function () {
      this.addRecord(global.STATISTIC_REALNAME_POP_SHOW)
      window.addEventListener('resize', function () {
        console.log('111进入')
        setTimeout(function () {
          let _mw = document.getElementsByClassName('M_certification')[0]
          document.body.style.top = '-' + document.body.scrollTop + 'px'
          _mw.style.top = (window.outerHeight - _mw.offsetHeight) / 2 + 'px'
        }, 0)
      })
    },
    mounted () {
      let timer = setInterval(function () {
        let wrap = document.getElementsByClassName('M_certification')[0]
        if (typeof wrap !== 'undefined' || typeof wrap !== undefined) {
          clearInterval(timer)
          let pos = (document.documentElement.clientHeight - wrap.clientHeight) / 2 + document.documentElement.scrollTop
          wrap.style.position = 'absolute'
          wrap.style.top = pos + 'px'
        }
      }, 200)
    },
    methods: {
      show: function () {
        this.display = true
      },
      confirm: function () {
        // this.display = false
        if (this.confirmCallback) {
          this.addRecord(global.STATISTIC_REALNAME_POP_BUTTON_CLICK)
          this.confirmCallback(this.cardId, this.name)
        }
      },
      close: function () {
        this.display = false
        if (this.closeCallback) {
          this.closeCallback()
        }
      }
    }
  }
</script>

<style scoped src="@v2/assets/css/modals.module.css"></style>



// WEBPACK FOOTER //
// IdentityConfirmModal.vue?5217389a